var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SettingsLayout", [
    _c("div", { staticClass: "information-view" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _vm.isFetchingVendor || _vm.isUpdatingVendor
            ? _c(
                "section",
                [_c("spinner-loader", { staticClass: "centerscreen" })],
                1
              )
            : _vm.errored
            ? _c("section", [_c("p", [_vm._v("An error occurred.")])])
            : _c(
                "section",
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center mb-4",
                    },
                    [
                      _c("h2", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(_vm.$t("Hotel Information"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.isEditing
                                  ? _vm.$t("save").toUpperCase()
                                  : _vm.$t("edit").toUpperCase()
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    { on: { submit: _vm.handleSubmit } },
                    [
                      _c("b-card", { staticClass: "mb-4" }, [
                        _c(
                          "h4",
                          { staticClass: "card-title border-bottom pb-2 mb-3" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("Basic Information")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-flex mb-4" }, [
                          _c(
                            "div",
                            { staticClass: "property-info flex-grow-1" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("Property Name"),
                                    "label-for": "property-name",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "property-name",
                                      placeholder: _vm.$t("Property Name"),
                                      type: "text",
                                      required: "",
                                      disabled: !_vm.isEditing,
                                    },
                                    model: {
                                      value: _vm.formData.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "name", $$v)
                                      },
                                      expression: "formData.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("Branding Accent"),
                                    "label-for": "brand-accent",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "color-picker-wrapper" },
                                    [
                                      _c("span", {
                                        staticClass: "current-color",
                                        class: { disabled: !_vm.isEditing },
                                        style:
                                          "background-color: " +
                                          _vm.formData.brand_accent_color,
                                        on: {
                                          click: function ($event) {
                                            _vm.isEditing
                                              ? _vm.toggleColorPicker($event)
                                              : null
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "color-value" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formData.brand_accent_color
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showPicker && _vm.isEditing
                                        ? _c("sketch-picker", {
                                            attrs: {
                                              value:
                                                _vm.formData.brand_accent_color,
                                              disableAlpha: "",
                                            },
                                            on: { input: _vm.updateColor },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("Address"),
                                    "label-for": "address-input",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "hidden",
                                    attrs: { type: "text" },
                                    model: {
                                      value: _vm.formData.latitude,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "latitude", $$v)
                                      },
                                      expression: "formData.latitude",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    staticClass: "hidden",
                                    attrs: { type: "text" },
                                    model: {
                                      value: _vm.formData.longitude,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "longitude", $$v)
                                      },
                                      expression: "formData.longitude",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("google-address-input", {
                                    attrs: {
                                      id: "address-input",
                                      place: _vm.formData.address,
                                      disabled: !_vm.isEditing,
                                    },
                                    on: { update: _vm.updateAddress },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-md-6 mb-3" },
                                  [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("Currency"))),
                                    ]),
                                    _vm._v(" "),
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.currency_options,
                                        disabled: !_vm.isEditing,
                                      },
                                      model: {
                                        value: _vm.formData.local_currency,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "local_currency",
                                            $$v
                                          )
                                        },
                                        expression: "formData.local_currency",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-6 mb-3" },
                                  [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("Language"))),
                                    ]),
                                    _vm._v(" "),
                                    _c("locale-switcher"),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mb-3" },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("Description"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-textarea", {
                                    attrs: {
                                      placeholder: _vm
                                        .$t("description_placeholder")
                                        .toLowerCase(),
                                      maxLength: "255",
                                      disabled: !_vm.isEditing,
                                    },
                                    model: {
                                      value: _vm.formData.description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "formData.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-4",
                              staticStyle: { width: "220px" },
                            },
                            [
                              _c("div", { staticClass: "mb-3" }, [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("Hotel Logo"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "hotel-information-image-container logo-image",
                                  },
                                  [
                                    _c(
                                      "photo-upload-container",
                                      {
                                        attrs: {
                                          "image-uri": _vm.formData.logo_uri,
                                        },
                                        on: {
                                          "click-add": function ($event) {
                                            return _vm.onClickFileInput("logo")
                                          },
                                        },
                                      },
                                      [
                                        !_vm.formData.logo_uri
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "image-container text-center",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(_vm.$t("Add Logo")) +
                                                    "\n                      "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("Hotel Image"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "hotel-information-image-container logo-image",
                                  },
                                  [
                                    _c(
                                      "photo-upload-container",
                                      {
                                        attrs: {
                                          "image-uri": _vm.formData.image_uri,
                                        },
                                        on: {
                                          "click-add": function ($event) {
                                            return _vm.onClickFileInput("photo")
                                          },
                                        },
                                      },
                                      [
                                        !_vm.formData.image_uri
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "image-container text-center",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.$t("Add Photo")
                                                    ) +
                                                    "\n                      "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("b-card", { staticClass: "mb-4" }, [
                        _c(
                          "h4",
                          { staticClass: "card-title border-bottom pb-2 mb-3" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("Contact Information")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-4 mb-3" },
                            [
                              _c("label", [_vm._v(_vm._s(_vm.$t("Website")))]),
                              _vm._v(" "),
                              !_vm.isEditing && _vm.formData.website
                                ? _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.formData.website) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: _vm
                                    .$t("website_placeholder")
                                    .toLowerCase(),
                                  type: "url",
                                  disabled: !_vm.isEditing,
                                },
                                model: {
                                  value: _vm.formData.website,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "website", $$v)
                                  },
                                  expression: "formData.website",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-4 mb-3" },
                            [
                              _c("label", [_vm._v(_vm._s(_vm.$t("Email")))]),
                              _vm._v(" "),
                              !_vm.isEditing && _vm.formData.email
                                ? _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.formData.email) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: _vm
                                    .$t("email_placeholder")
                                    .toLowerCase(),
                                  type: "email",
                                  disabled: !_vm.isEditing,
                                },
                                model: {
                                  value: _vm.formData.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "email", $$v)
                                  },
                                  expression: "formData.email",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-4 mb-3" },
                            [
                              _c("label", [_vm._v(_vm._s(_vm.$t("Phone")))]),
                              _vm._v(" "),
                              !_vm.isEditing && _vm.formData.phone_number
                                ? _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.formData.phone_number) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  placeholder: _vm
                                    .$t("phone_placeholder")
                                    .toLowerCase(),
                                  type: "tel",
                                  disabled: !_vm.isEditing,
                                },
                                model: {
                                  value: _vm.formData.phone_number,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "phone_number", $$v)
                                  },
                                  expression: "formData.phone_number",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.sectionVisibility.payments
                        ? _c("b-card", { staticClass: "mb-4" }, [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "card-title border-bottom pb-2 mb-3",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Payment Methods")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "Accepted Payment Methods"
                                        ),
                                      },
                                    },
                                    [
                                      !_vm.isEditing
                                        ? _c(
                                            "div",
                                            { staticClass: "payment-methods" },
                                            [
                                              _c(
                                                "b-badge",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: { variant: "info" },
                                                },
                                                [_vm._v("CASH")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-badge",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: { variant: "info" },
                                                },
                                                [_vm._v("CC")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-badge",
                                                { attrs: { variant: "info" } },
                                                [_vm._v("PAYPAL")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          disabled: !_vm.isEditing,
                                          placeholder: _vm.$t(
                                            "Enter accepted payment methods"
                                          ),
                                        },
                                        model: {
                                          value: _vm.formData.accepted_payments,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "accepted_payments",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.accepted_payments",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sectionVisibility.amenities
                        ? _c("b-card", { staticClass: "mb-4" }, [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "card-title border-bottom pb-2 mb-3",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Amenities")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("Available Amenities"),
                                      },
                                    },
                                    [
                                      !_vm.isEditing
                                        ? _c(
                                            "div",
                                            { staticClass: "amenities-list" },
                                            _vm._l(
                                              _vm.amenities,
                                              function (amenity) {
                                                return _c(
                                                  "b-badge",
                                                  {
                                                    key: amenity,
                                                    staticClass: "mr-2 mb-2",
                                                    attrs: { variant: "info" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(amenity) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          disabled: !_vm.isEditing,
                                          placeholder:
                                            _vm.$t("Enter amenities"),
                                        },
                                        model: {
                                          value: _vm.formData.amenities,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "amenities",
                                              $$v
                                            )
                                          },
                                          expression: "formData.amenities",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sectionVisibility.socialMedia
                        ? _c("b-card", { staticClass: "mb-4" }, [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "card-title border-bottom pb-2 mb-3",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Social Media")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3" },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("Facebook"))),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.isEditing && _vm.formData.facebook
                                    ? _c("p", { staticClass: "mb-0" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.formData.facebook) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: _vm.$t("Facebook URL"),
                                      disabled: !_vm.isEditing,
                                    },
                                    model: {
                                      value: _vm.formData.facebook,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "facebook", $$v)
                                      },
                                      expression: "formData.facebook",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3" },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("Instagram"))),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.isEditing && _vm.formData.instagram
                                    ? _c("p", { staticClass: "mb-0" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.formData.instagram) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: _vm.$t("Instagram handle"),
                                      disabled: !_vm.isEditing,
                                    },
                                    model: {
                                      value: _vm.formData.instagram,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "instagram", $$v)
                                      },
                                      expression: "formData.instagram",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3" },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("Twitter"))),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.isEditing && _vm.formData.twitter
                                    ? _c("p", { staticClass: "mb-0" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.formData.twitter) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: _vm.$t("Twitter handle"),
                                      disabled: !_vm.isEditing,
                                    },
                                    model: {
                                      value: _vm.formData.twitter,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "twitter", $$v)
                                      },
                                      expression: "formData.twitter",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3" },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("Snapchat"))),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.isEditing && _vm.formData.snapchat
                                    ? _c("p", { staticClass: "mb-0" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.formData.snapchat) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: _vm.$t("Snapchat username"),
                                      disabled: !_vm.isEditing,
                                    },
                                    model: {
                                      value: _vm.formData.snapchat,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "snapchat", $$v)
                                      },
                                      expression: "formData.snapchat",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3" },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("Pinterest"))),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.isEditing && _vm.formData.pinterest
                                    ? _c("p", { staticClass: "mb-0" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.formData.pinterest) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: _vm.$t("Pinterest username"),
                                      disabled: !_vm.isEditing,
                                    },
                                    model: {
                                      value: _vm.formData.pinterest,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "pinterest", $$v)
                                      },
                                      expression: "formData.pinterest",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sectionVisibility.directBooking
                        ? _c("b-card", { staticClass: "mb-4" }, [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "card-title border-bottom pb-2 mb-3",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Direct Booking Settings")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-6 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("Direct Booking"),
                                      },
                                    },
                                    [
                                      _c("toggle-button", {
                                        attrs: {
                                          disabled: !_vm.isEditing,
                                          sync: true,
                                          labels: {
                                            checked: "On",
                                            unchecked: "Off",
                                          },
                                          width: 100,
                                          height: 33,
                                          color: "#82C7EB",
                                        },
                                        model: {
                                          value:
                                            _vm.formData.direct_booking_enabled,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "direct_booking_enabled",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.direct_booking_enabled",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-6 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("Direct Booking URL"),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "booking-url" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.directBookingUrl) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-6 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("Discount Enabled"),
                                      },
                                    },
                                    [
                                      _c("toggle-button", {
                                        attrs: {
                                          disabled: !_vm.isEditing,
                                          sync: true,
                                          labels: {
                                            checked: "On",
                                            unchecked: "Off",
                                          },
                                          width: 100,
                                          height: 33,
                                          color: "#82C7EB",
                                        },
                                        model: {
                                          value: _vm.formData.discount_enabled,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "discount_enabled",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.discount_enabled",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-6 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: { label: _vm.$t("Items Enabled") },
                                    },
                                    [
                                      _c("toggle-button", {
                                        attrs: {
                                          disabled: !_vm.isEditing,
                                          sync: true,
                                          labels: {
                                            checked: "On",
                                            unchecked: "Off",
                                          },
                                          width: 100,
                                          height: 33,
                                          color: "#82C7EB",
                                        },
                                        model: {
                                          value: _vm.formData.item_enabled,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "item_enabled",
                                              $$v
                                            )
                                          },
                                          expression: "formData.item_enabled",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-6 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("Email Confirmation"),
                                      },
                                    },
                                    [
                                      _c("toggle-button", {
                                        attrs: {
                                          disabled: !_vm.isEditing,
                                          sync: true,
                                          labels: {
                                            checked: "On",
                                            unchecked: "Off",
                                          },
                                          width: 100,
                                          height: 33,
                                          color: "#82C7EB",
                                        },
                                        model: {
                                          value:
                                            _vm.formData.email_confirmation,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "email_confirmation",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.email_confirmation",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-6 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("Minimum Nights"),
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        class: [
                                          "input-info-field",
                                          {
                                            "input-error":
                                              _vm.fieldState.min_nights ===
                                              false,
                                          },
                                        ],
                                        attrs: {
                                          disabled: !_vm.isEditing,
                                          "field-state":
                                            _vm.fieldState.min_nights,
                                          type: "number",
                                          min: "1",
                                          step: "1",
                                        },
                                        model: {
                                          value: _vm.formData.min_nights,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "min_nights",
                                              $$v
                                            )
                                          },
                                          expression: "formData.min_nights",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("Deposit Policy"),
                                      },
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          disabled: !_vm.isEditing,
                                          placeholder: _vm.$t(
                                            "Enter deposit policy"
                                          ),
                                        },
                                        model: {
                                          value: _vm.formData.deposit_policy,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "deposit_policy",
                                              $$v
                                            )
                                          },
                                          expression: "formData.deposit_policy",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-6 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("Enable Payment"),
                                      },
                                    },
                                    [
                                      _c("toggle-button", {
                                        attrs: {
                                          disabled:
                                            !_vm.isEditing ||
                                            !_vm.formData.stripe_id,
                                          sync: true,
                                          labels: {
                                            checked: "Yes",
                                            unchecked: "No",
                                          },
                                          width: 100,
                                          height: 33,
                                          color: "#82C7EB",
                                        },
                                        model: {
                                          value: _vm.formData.payment_enabled,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "payment_enabled",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.payment_enabled",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sectionVisibility.channelManager
                        ? _c("b-card", { staticClass: "mb-4" }, [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "card-title border-bottom pb-2 mb-3",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Channel Manager Settings")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("Auto Sync Unit"),
                                      },
                                    },
                                    [
                                      _c("toggle-button", {
                                        attrs: {
                                          disabled: !_vm.isEditing,
                                          sync: true,
                                          labels: {
                                            checked: "On",
                                            unchecked: "Off",
                                          },
                                          width: 100,
                                          height: 33,
                                          color: "#82C7EB",
                                        },
                                        model: {
                                          value: _vm.formData.auto_sync_unit,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "auto_sync_unit",
                                              $$v
                                            )
                                          },
                                          expression: "formData.auto_sync_unit",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("Auto Sync Rate"),
                                      },
                                    },
                                    [
                                      _c("toggle-button", {
                                        attrs: {
                                          disabled: !_vm.isEditing,
                                          sync: true,
                                          labels: {
                                            checked: "On",
                                            unchecked: "Off",
                                          },
                                          width: 100,
                                          height: 33,
                                          color: "#82C7EB",
                                        },
                                        model: {
                                          value: _vm.formData.auto_sync_rate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "auto_sync_rate",
                                              $$v
                                            )
                                          },
                                          expression: "formData.auto_sync_rate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: { label: _vm.$t("Auto Sync AVR") },
                                    },
                                    [
                                      _c("toggle-button", {
                                        attrs: {
                                          disabled: !_vm.isEditing,
                                          sync: true,
                                          labels: {
                                            checked: "On",
                                            unchecked: "Off",
                                          },
                                          width: 100,
                                          height: 33,
                                          color: "#82C7EB",
                                        },
                                        model: {
                                          value: _vm.formData.auto_sync_avr,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "auto_sync_avr",
                                              $$v
                                            )
                                          },
                                          expression: "formData.auto_sync_avr",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sectionVisibility.salesSettings
                        ? _c("b-card", { staticClass: "mb-4" }, [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "card-title border-bottom pb-2 mb-3",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Sales Settings")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: _vm.$t("Tip Rate 1") } },
                                    [
                                      _c("currency-input", {
                                        staticClass: "info-tip-rate-input",
                                        attrs: {
                                          name: "Tip Rate 1",
                                          "currency-symbol": "%",
                                          size: 6,
                                          amount: _vm.formData.tip_rate_1,
                                          disabled: !_vm.isEditing,
                                          "field-state":
                                            _vm.fieldState.tip_rate_1,
                                        },
                                        on: {
                                          "update:amount": function ($event) {
                                            return _vm.$set(
                                              _vm.formData,
                                              "tip_rate_1",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: _vm.$t("Tip Rate 2") } },
                                    [
                                      _c("currency-input", {
                                        staticClass: "info-tip-rate-input",
                                        attrs: {
                                          name: "Tip Rate 2",
                                          "currency-symbol": "%",
                                          size: 6,
                                          amount: _vm.formData.tip_rate_2,
                                          disabled: !_vm.isEditing,
                                          "field-state":
                                            _vm.fieldState.tip_rate_2,
                                        },
                                        on: {
                                          "update:amount": function ($event) {
                                            return _vm.$set(
                                              _vm.formData,
                                              "tip_rate_2",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: _vm.$t("Tip Rate 3") } },
                                    [
                                      _c("currency-input", {
                                        staticClass: "info-tip-rate-input",
                                        attrs: {
                                          name: "Tip Rate 3",
                                          "currency-symbol": "%",
                                          size: 6,
                                          amount: _vm.formData.tip_rate_3,
                                          disabled: !_vm.isEditing,
                                          "field-state":
                                            _vm.fieldState.tip_rate_3,
                                        },
                                        on: {
                                          "update:amount": function ($event) {
                                            return _vm.$set(
                                              _vm.formData,
                                              "tip_rate_3",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
          _vm._v(" "),
          _c("input", {
            ref: "file-input",
            staticStyle: { display: "none" },
            attrs: { type: "file" },
            on: { change: _vm.onFileChanged },
          }),
          _vm._v(" "),
          _c("image-upload-modal", { ref: "upload-modal" }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }